import { render, staticRenderFns } from "./AuthRoot.vue?vue&type=template&id=09de56d2&scoped=true&"
import script from "./AuthRoot.vue?vue&type=script&lang=ts&"
export * from "./AuthRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de56d2",
  null
  
)

export default component.exports